document.addEventListener("turbo:load", function() {
  const container = document.getElementById("custom-question-option-fields");
  if (!container) return;

  console.log("Load: custom_question_option_fields.js");

  $("#new_option").on('click', function(e) {
    e.preventDefault();
    console.log('click');
    var template = document.getElementById('option-template').innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    $('#custom-question-answers').append(template);
  });

  $(document).on('click', '.destroy-custom-option', function(e) {
    var parentDiv = $(this).closest('.form_field');
    if($(this).is(':checked') && parentDiv.attr('data-new-record') == 'true') {
      parentDiv.remove();
    }
  });
});